import { Component, OnInit, OnDestroy } from '@angular/core';

import { Store } from '@src/store';
import { DialogManagerService } from '@src/services';
import { userActions } from '@src/store/reducers/userReducer';

import * as _ from 'lodash';

@Component({
    selector: 'project-groups',
    template: require('./project-groups.component.html'),
    styles: [require('./project-groups.component.scss')]
})
export class ProjectGroupsComponent implements OnInit, OnDestroy {
    public projectGroups: any[];
    public projectGroup: any;

    private unSubscribers: any[];
    private unSubscribe: any;
    private indexInList: number = 0;

    constructor(
        private store: Store,
        private dialogManagerService: DialogManagerService) {
    }

    public async ngOnInit() {
        this.unSubscribe = this.store.subscribe(() => {
            const userState = this.store.getState().user;
            if (userState.projectGroups) {
                const projects = userState.projectGroups;
                this.projectGroups = projects;
                this.projectGroup = userState.projectGroup;
                this.unSubscribe();
            }
        });
        this.projectGroups = await this.store.dispatch({ type: userActions.GET_PROJECT_GROUPS });
        
        this.unSubscribers = [
            this.store.subscribe(() => {
                const userState = this.store.getState().user;
                if (userState.projectGroup) {
                    // const projects = userState.projectGroups;
                    // this.projectGroups = projects;
                    this.projectGroup = userState.projectGroup;
                    const existGroup = this.projectGroups.find((group: any) => this.projectGroup.id === group.id);
                    if (existGroup) {
                        existGroup.name = this.projectGroup.name;
                    }
                }
            })
        ];
    }

    public ngOnDestroy() {
        this.unSubscribers.forEach(us => us());
    }

    public addProjectGroup() {
        this.projectGroup = {
            name: 'New PG',
            isNew: true,
            pipelineIds: [],
            sourceControlFolder: null,
            sourceControlPathType: 0
        };
        this.projectGroups = [this.projectGroup, ...this.projectGroups];
        this.indexInList = 0;
    }

    public getProjectGroup(selectedProjectGroup: any, indexInList: any) {
        this.indexInList = indexInList;
        if (selectedProjectGroup.isNew) {
            this.projectGroup = selectedProjectGroup;
            return;
        }
        this.store.dispatch({
            type: userActions.GET_PROJECT_GROUP,
            payload: { projectGroupId: selectedProjectGroup.id }
        });
    }

    public deleteProjectGroup() {
        if (!this.projectGroup.isNew)
        {
            this.dialogManagerService.showConfirmationDialog(
                {
                    title: 'Delete Project Group',
                    action: 'delete',
                    objectType: 'group',
                    item: this.projectGroup.name
                },
                () => {
                    if (this.projectGroup.isNew) {
                        if (this.indexInList >= 0) {
                            this.projectGroups = [
                                ...this.projectGroups.slice(0, this.indexInList),
                                ...this.projectGroups.slice(this.indexInList + 1)
                            ];
                            this.projectGroup = this.projectGroups ? this.projectGroups[0] : null;
                        }
                        return;
                    }
                    this.unSubscribe = this.store.subscribe(() => {
                        const user = this.store.getState().user;
                        if (user.projectGroups) {
                            if (this.projectGroups.length > user.projectGroups.length) {
                                this.projectGroups = user.projectGroups;
                                this.projectGroup = user.projectGroup;
                                this.unSubscribe();
                            }
                        }
                    });
                    this.store.dispatch({
                        type: userActions.DELETE_PROJECT_GROUP,
                        payload: { projectGroupId: this.projectGroup.id }
                    });
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/advancedManagement/project-groups/project-groups.component.ts